export default __webpack_public_path__ + "87f6eb0c6d3a36c5edba414b75bf99c3.png";